import { merge, each } from 'lodash-es';
import page from 'page';

function urlToPath(url, includeHash = true) {
  const { pathname, search, hash } = url;
  return pathname + search + (includeHash && url.hash ? hash : '');
}

const defaultNavigateOpts = {
  replace: false,
  query: {},
  hash: null
};

export function navigate(url, opts) {
  if (typeof url != 'string' && !(url instanceof URL) && !(url instanceof Location)) {
    opts = url;
    url = location;
  }
  opts = merge({}, defaultNavigateOpts, opts);

  url = new URL(url, document.baseURI);
  each(opts.query, (val, key) => {
    if (val) {
      url.searchParams.set(key, val);
    } else {
      url.searchParams.delete(key);
    }
  });
  if (typeof opts.hash == 'string') url.hash = opts.hash;

  const path = urlToPath(url);
  if (opts.replace) {
    page.redirect(path);
  } else {
    page(path);
  }
}